import { useEffect, useCallback, RefObject } from 'react';

const useOutsideHandler = (ref: RefObject<HTMLDivElement>, onBlur: () => void): void => {
  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onBlur();
      }
    },
    [onBlur, ref]
  );

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);
};

export default useOutsideHandler;
